<template>
  <div class="back">
    <div class="search">
      <crumb :prevLevel="prevLevel" :current="current" />
      <div class="form-contaner">
        <el-form label-width="80px" class="form">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="企业名称">
                <el-input
                  placeholder="请输入企业名称"
                  v-model="queryParams.enterpriseName"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="预警类型">
                <el-select v-model="queryParams.warnTypes">
                  <el-option
                    v-for="item in optionsList"
                    :label="item.label"
                    :value="item.value"
                    :key="item.value"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="处理状态">
                <el-select v-model="queryParams.handleStatus">
                  <el-option label="全部" value="" />
                  <el-option
                    :key="key"
                    v-for="(item, key) in dealStatusMap"
                    :label="item"
                    :value="key"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <el-button type="primary" @click="init">查询</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="line">
      <div class="title" style="padding-left:10px">
        预警数量统计
      </div>
    </div>
    <Echarts :echartsOption="echartsOption" echartsHeight="350px" />
    <div class="line" style="margin-top:20px">
      <div class="title" style="padding-left:10px">
        预警信息列表
      </div>
    </div>
    <warning-list
      :warningList="warningList"
      :total="warningTotalCount"
      @current-change="loadWarnList"
    />
  </div>
</template>

<script>
import Echarts from 'components/echarts/echarts';
import Crumb from 'components/crumb/crumb';
import WarningList from 'components/warning/list';

const waringTypeMap = {
  production: {
    license: [
      {
        label: '全部',
        value: '12,13'
      },
      {
        value: '12',
        label: '营业执照过期'
      },
      {
        value: '13',
        label: '生产许可证过期'
      }
    ],
    material: [
      {
        value: '7,10,15,6',
        label: '全部'
      },
      {
        value: '7',
        label: '原辅料检验报告缺失'
      },
      {
        value: '10',
        label: '原辅料过效期'
      },
      {
        value: '15',
        label: '非指定供应商'
      },
      {
        value: '6',
        label: '原辅料检验不合格'
      }
    ],
    production: [
      {
        label: '全部',
        value: '9,14,8,17'
      },
      {
        label: '成品检验报告缺失',
        value: '9'
      },
      {
        label: '温湿度异常',
        value: '14'
      },
      {
        label: '成品检验不合格',
        value: '8'
      },
      {
        label: '洁净度超限',
        value: '17'
      }
    ],
    sell: [
      {
        label: '全部',
        value: '2,11,18'
      },
      {
        label: '过效期销售',
        value: '2'
      },
      {
        label: '过效期库存',
        value: '11'
      },
      {
        label: '进销不平衡',
        value: '18'
      }
    ]
  },
  circulate: {
    license: [
      {
        label: '全部',
        value: '12,13'
      },
      {
        value: '12',
        label: '营业执照过期'
      },
      {
        value: '13',
        label: '经营许可证过期'
      }
    ],
    transport: [
      {
        value: '14,15',
        label: '全部'
      },
      {
        value: '14',
        label: '温湿度异常'
      },
      {
        value: '15',
        label: '非指定供应商'
      }
    ],
    sell: [
      {
        label: '全部',
        value: '2,11,18,19,20'
      },
      {
        label: '过效期销售',
        value: '2'
      },
      {
        label: '过效期库存',
        value: '11'
      },
      {
        label: '进销不平衡',
        value: '18'
      },
      {
        label: '经营范围超限',
        value: '19'
      },
      {
        label: '召回品销售',
        value: '20'
      }
    ]
  }
};

const warningCodeMap = {
  license: '证照过期列表',
  material: '原辅料异常列表',
  production: '生产存储异常列表',
  sell: '进销存异常列表',
  transport: '仓储运输异常列表'
};

export default {
  data() {
    return {
      current: '',
      typeID: '',
      waringBigType: '',
      prevLevel: '',
      optionsList: [],
      queryParams: {
        enterpriseName: '',
        warnTypes: '12,13,7,10,15,69,14,8,17,2,11,18',
        handleStatus: ''
      },
      echartsOption: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '3%',
          bottom: '12%',
          top: '2%',
          containLabel: true
        },
        legend: {
          data: [],
          bottom: 0,
          itemWidth: 16,
          itemHeight: 4
        },
        xAxis: {
          type: 'category',
          boundaryGap: [0, 0.01],
          splitLine: {
            show: false
          },

          axisTick: {
            show: false,
            alignWithLabel: true
          },
          axisLabel: {
            interval: 0,
            textStyle: {
              color: '#666'
            }
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(206,219,239,0.5)'
            }
          }
        },
        yAxis: {
          type: 'value',
          axisTick: {
            show: false
          },
          minInterval: 1,
          axisLabel: {
            textStyle: {
              color: '#999'
            }
          },
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(206,219,239,0.5)'
            }
          },
          data: []
        },
        series: []
      },
      colors: [
        ['rgba(81, 64, 198, 1)', 'rgba(56, 108, 226, 1)'],
        ['rgba(255, 180, 57, 1)', 'rgba(255, 215, 57, 1)'],
        ['rgba(43, 191, 153, 1)', 'rgba(31, 244, 189, 1)'],
        ['rgba(135, 65, 197, 1)', 'rgba(149, 112, 233, 1)'],
        ['rgba(171, 184, 204, 1)', 'rgba(171, 184, 204, 1)']
      ],
      warningList: [],
      warningTotalCount: 0
    };
  },
  computed: {
    dealStatusMap() {
      return JSON.parse(JSON.stringify(this.$common.warnDealStatus));
    }
  },
  components: {
    Echarts,
    WarningList,
    Crumb
  },
  mounted() {
    const { waringBigType, waringSmallType } = this.$route.params;
    this.queryParams.warnTypes =
      waringTypeMap[waringBigType][waringSmallType][0].value;
    this.optionsList = waringTypeMap[waringBigType][waringSmallType];
    this.prevLevel = waringBigType === 'production' ? '生产预警' : '流通预警';
    this.waringBigType = waringBigType;
    this.init();
    this.current = warningCodeMap[waringSmallType];
  },
  methods: {
    init() {
      this.loadEchartsData();
      this.loadWarnList(1);
    },
    loadEchartsData() {
      this.$request({
        url: 'rest/riskwarning/produce/riskWarnListBarByType',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: 1,
              pageSize: 100000
            },
            params: {
              ...this.queryParams,
              warnTypes: this.queryParams.warnTypes.split(','),
              enterpriseType:
                this.waringBigType === 'production' ? ['1'] : ['0', '2']
            }
          })
        }
      }).then(res => {
        this.echartsOption.xAxis.data = res.enterpriseList;
        const series = [];
        const legend = [];
        res.dataList.forEach((item, index) => {
          series.push({
            name: this.$common.getWarningTypeText(
              item.name,
              this.$common.entType[this.waringBigType]
            ),
            type: 'bar',
            barWidth: '8px',
            data: item.data,
            itemStyle: {
              color: this.colorGradual(...this.colors[index])
            }
          });
          legend.push(
            this.$common.getWarningTypeText(
              item.name,
              this.$common.entType[this.waringBigType]
            )
          );
        });
        this.echartsOption.legend.data = legend;
        this.echartsOption.series = series;
      });
    },
    loadWarnList(currentPage) {
      this.currentPage = currentPage;
      this.$request({
        url: 'rest/riskwarning/produce/warnDetailList',
        data: {
          json: JSON.stringify({
            pageBean: {
              pageNum: this.currentPage,
              pageSize: 10
            },
            params: {
              ...this.queryParams,
              warnTypes: this.queryParams.warnTypes.split(','),
              enterpriseType:
                this.waringBigType === 'production' ? ['1'] : ['0', '2']
            }
          })
        }
      }).then(res => {
        this.warningList = res.list.map(item => ({
          ...item,
          enterprise_type: this.$common.entType[this.waringBigType]
        }));
        this.warningTotalCount = res.total;
      });
    },
    colorGradual(color1, color2) {
      return new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
        { offset: 1, color: color1 },
        { offset: 0, color: color2 }
      ]);
    }
  }
};
</script>

<style lang="stylus" scoped>
.back
  padding 0 20px 15px 20px
  border-radius 4px
  background #fff
  .el-pagination
    text-align right
    margin 20px 0 0 0
  .search
    .form-contaner
      padding 30px 20px 0 0px
      text-align center
      .el-form-item__label
        color #444 !important
      .form
        margin-bottom 30px
  .line
    height auto
    overflow hidden
    border-bottom 1px solid rgba(206,219,239,0.5)
    margin 0 0 20px 0
    .title
      height 40px
      line-height 40px
      color #242424
      font-size 14px
.el-table
  >>>td
    height 60px
</style>
